import { render } from "./smartgoal.vue?vue&type=template&id=5a502cbf"
import script from "./smartgoal.vue?vue&type=script&lang=js"
export * from "./smartgoal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__